import { AppRoutes } from '../../App/routes';

export const adminRoot = 'admin';
export const adminDevManageRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}/${adminRoot}`;

export const systemQuery = '?tab=systems';
export const adminSystemManageRoute = `${adminDevManageRoute}${systemQuery}`;
